/* global axios */
import ApiClient from "dashboard/api/ApiClient";

class CRMActivitiesAPI extends ApiClient {
  constructor() {
    super("crm/activities", { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.put(`${this.url}/${id}`, payload);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new CRMActivitiesAPI();
